import React, { ReactNode } from "react"

import { LoadingIndicator } from "@axtesys/kassen-app-ui"

import { useSetupTranslationService } from "../hooks"
import DE_PORTAL_RESOURCE from "../locales/de/web/resource"

export default function WebTranslationProvider({
  children,
}: {
  children: ReactNode
}) {
  const isInitialised = useSetupTranslationService({ de: DE_PORTAL_RESOURCE })

  if (!isInitialised) return <LoadingIndicator />

  return <>{children}</>
}
